var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPaperplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1438_9825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2711 6.73131L19.745 9.9115L39.8762 5.98769L29.0032 13.6771L42.3676 20.4014C43.0443 20.7495 43.8748 20.4172 44.167 19.7052L51.795 0.798127C51.9334 0.465869 51.672 0.117788 51.3182 0.165254L11.3787 5.7029C10.8405 5.782 10.7636 6.54145 11.2711 6.73131Z",
    fill: "url(#paint0_radial_1438_9825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7598 9.92719L23.9121 24.6731L29.0026 13.677L39.8756 5.98755L19.7598 9.92719Z",
    fill: "#410E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9121 24.6734L34.4622 16.4144L29.0026 13.6772L23.9121 24.6734Z",
    fill: "#B39FCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0818 39.9999C14.7282 39.9999 14.4053 39.751 14.3284 39.3776C14.0055 37.7442 13.6673 36.2818 13.3137 34.975C10.1926 36.6863 6.88711 37.8375 4.33493 37.0752C2.36698 36.484 1.04476 34.8972 0.414405 32.3459C-0.446572 28.9545 0.983266 25.4075 3.88906 23.7118C5.42652 22.8095 6.99473 22.685 8.40919 23.3384C10.7461 24.4118 12.668 27.461 14.2515 32.6104C17.4956 30.5724 20.5397 28.0522 22.0926 26.5898C22.4001 26.2942 22.8921 26.3098 23.1842 26.6365C23.4763 26.9476 23.4609 27.4454 23.1381 27.741C22.8613 28.0055 19.1099 31.4903 14.6974 34.1816C15.0971 35.6595 15.4815 37.293 15.8351 39.0821C15.912 39.5021 15.6506 39.9066 15.2355 39.9999C15.174 39.9999 15.1279 39.9999 15.0818 39.9999ZM6.54887 24.4896C5.94926 24.4896 5.3189 24.6763 4.65779 25.0652C2.3516 26.4031 1.22926 29.2345 1.90574 31.957C2.4131 33.9638 3.35095 35.1461 4.78079 35.5817C6.90248 36.2196 9.9159 35.115 12.8832 33.4349C11.1151 27.5232 9.20867 25.423 7.77884 24.7696C7.3791 24.583 6.96398 24.4896 6.54887 24.4896Z",
    fill: "#5C18B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1438_9825",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3891 31.4945) rotate(-139.8) scale(63.1473 28.7527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC2BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231727,
    stopColor: "#540FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC2BED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1438_9825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.6667,
    height: 40,
    fill: "white",
    transform: "translate(0.166016)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPaperplane);
export default __webpack_public_path__ + "static/media/img_paperplane.639fd3b6d5ad50c51b47142a6882d382.svg";
export { ForwardRef as ReactComponent };